module.exports = __webpack_public_path__ + "img/wc.6a09f5fd.png";